import { useAppStore } from '@/state'
import { getCookie } from '@/lib/api/client'
import { JWT_TOKEN_COOKIE_NAME } from '@/external/onshape/constants'

export const useJwtToken = () => {
  const token = useAppStore(
    (state) => state.jwtToken || getCookie(JWT_TOKEN_COOKIE_NAME),
  )
  return token
}
